import classnames from 'classnames';
import * as React from 'react';
import SvgInline from '@latitude/svg-inline';
import './_search-button.scss';

var SearchButton = function SearchButton(props) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    name: "Latitude Search Button",
    className: classnames('trackcustomanalytics search-button', props.className, {
      visible: props.visible
    })
    /* js-show-search-button */
    ,
    "data-trackid": "nav-search",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(SvgInline, {
    className: "search-bar-icon",
    "aria-label": "Search",
    name: "search"
  }));
};

export default SearchButton;